import React, { useState } from 'react';
import { useMobxStores } from '@stores/store';
import moment from 'moment';

/* 미디어 타입:이미지 */
const ImageUnit = ({ data }) => {
  const { mediaStore, settingStore } = useMobxStores();

  return (
    <>
      <div>
        <div className={'relative w-full h-[0] pb-[56.26%] overflow-hidden'}>
          <img
            src={data.thumbUrl}
            alt={data.title}
            className=" object-cover rounded-[1px] absolute top-0 left-0 w-full h-full bg-[#eee]"
          />
        </div>
        <p
          className={
            'text-[14px] xl:text-[18px] pt-1 text-left text-ellipsis line-clamp-2'
          }
        >
          {data.title}
        </p>
      </div>
    </>
  );
};

export default ImageUnit;
